module.exports = __webpack_public_path__ + "static/media/gear-icon.bbbb48d1.svg";